import { useApiData } from 'lib/api';
import { useReduxState } from 'hooks';
import { Owners, TitleWithIcon } from 'components/common';
import { Box, BoxRow } from 'components/common/box';

const AchievementPaths = () => {
  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const { data, loading } = useApiData({
    url: `/admin/achievements/${achievement.id}/paths`
  });

  return data?.paths?.length ? (
    <div className="paths">
      <Box
        loading={loading}
        padding={0}
        title={messages.paths}
        titleTooltip={messages.achievementPathInfo}
      >
        {data.paths.map((path) => (
          <BoxRow key={path.id}>
            <div className="row row-center">
              <div className="col">
                <TitleWithIcon
                  icon="tasks"
                  title={path.title}
                  titleLink={{
                    as: `/admin/paths/${path.id}`,
                    href: '/admin/paths/[pathId]'
                  }}
                >
                  <Owners owners={path.owners} />
                </TitleWithIcon>
              </div>
            </div>
          </BoxRow>
        ))}
      </Box>

      <style jsx>{`
        .paths {
          margin-top: 50px;
        }
      `}</style>
    </div>
  ) : null;
};

export default AchievementPaths;
